var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    strokeWidth: 2.8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4166 2.37724V8.16C15.4166 8.94407 15.4166 9.33611 15.5665 9.63559C15.6983 9.89901 15.9087 10.1132 16.1674 10.2474C16.4615 10.4 16.8466 10.4 17.6166 10.4H23.2961M23.6666 13.1835V23.28C23.6666 25.6322 23.6666 26.8083 23.217 27.7068C22.8216 28.497 22.1905 29.1396 21.4143 29.5422C20.532 30 19.3768 30 17.0666 30H8.26663C5.95641 30 4.8013 30 3.91892 29.5422C3.14275 29.1396 2.5117 28.497 2.11622 27.7068C1.66663 26.8083 1.66663 25.6322 1.66663 23.28V8.72C1.66663 6.36778 1.66663 5.19167 2.11622 4.29324C2.5117 3.50296 3.14275 2.86044 3.91892 2.45777C4.8013 2 5.95641 2 8.26663 2H12.6828C13.6918 2 14.1962 2 14.671 2.11605C15.0919 2.21893 15.4942 2.38863 15.8633 2.61891C16.2796 2.87865 16.6363 3.24185 17.3497 3.96824L21.7335 8.43176C22.447 9.15815 22.8037 9.52135 23.0588 9.9452C23.2849 10.321 23.4516 10.7307 23.5527 11.1592C23.6666 11.6426 23.6666 12.1562 23.6666 13.1835Z",
    stroke: "#2C67F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.f05adb7855ade4939efb9e695e2844a3.svg";
export { ForwardRef as ReactComponent };